function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from '.';
export function CollapseButton(_ref) {
  let {
    onClick,
    disabled = false,
    saveParams = [],
    text = 'hide',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "submit",
    icon: "compress",
    loading: false,
    onClick: () => onClick && onClick(...saveParams),
    "data-testid": "compress_button",
    disabled: disabled
  }, props), text);
}
;